/**
 * Secure token storage utility.
 * Provides basic obfuscation for tokens stored in sessionStorage instead of localStorage.
 * sessionStorage is slightly more secure (cleared on tab close) and we add base64 encoding
 * to prevent casual inspection.
 *
 * For banking-grade production, replace with httpOnly cookie-based auth.
 */

const STORAGE_PREFIX = '_sm_sec_';

function encode(value) {
  try {
    return btoa(encodeURIComponent(value));
  } catch {
    return value;
  }
}

function decode(value) {
  try {
    return decodeURIComponent(atob(value));
  } catch {
    return value;
  }
}

export const secureStorage = {
  setToken(token) {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + 'tk', encode(token));
    } catch {
      // Fallback silently
    }
  },

  getToken() {
    try {
      const raw = sessionStorage.getItem(STORAGE_PREFIX + 'tk');
      return raw ? decode(raw) : null;
    } catch {
      return null;
    }
  },

  setUser(user) {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + 'usr', encode(JSON.stringify(user)));
    } catch {
      // Fallback silently
    }
  },

  getUser() {
    try {
      const raw = sessionStorage.getItem(STORAGE_PREFIX + 'usr');
      return raw ? JSON.parse(decode(raw)) : null;
    } catch {
      return null;
    }
  },

  clear() {
    try {
      sessionStorage.removeItem(STORAGE_PREFIX + 'tk');
      sessionStorage.removeItem(STORAGE_PREFIX + 'usr');
      // Also clear legacy localStorage keys
      localStorage.removeItem('sm_token');
      localStorage.removeItem('sm_user');
    } catch {
      // Fallback silently
    }
  },

  // Migration: check if old localStorage tokens exist and migrate
  migrateFromLocalStorage() {
    try {
      const oldToken = localStorage.getItem('sm_token');
      const oldUser = localStorage.getItem('sm_user');
      if (oldToken) {
        this.setToken(oldToken);
        localStorage.removeItem('sm_token');
      }
      if (oldUser) {
        this.setUser(JSON.parse(oldUser));
        localStorage.removeItem('sm_user');
      }
    } catch {
      // Ignore migration errors
    }
  }
};
